import type { ItemUI } from '@libs/common-node';
import { DeliveryType } from '@libs/core';

export const isItemIneligibleForAsBopisSdd = (
    item: ItemUI,
    fulfillmentMethod: DeliveryType,
    currentFulfillmentMethod?: string | null
): boolean => {
    if (!item.asOverride) {
        return false;
    }

    const isAutoship = Boolean(item.autoshipFrequency);
    const isBopisOrSdd = fulfillmentMethod === DeliveryType.BOPIS || fulfillmentMethod === DeliveryType.SDD;
    const isCurrentMethodBopisOrSdd =
        currentFulfillmentMethod === DeliveryType.BOPIS || currentFulfillmentMethod === DeliveryType.SDD;

    return isAutoship && isBopisOrSdd && isCurrentMethodBopisOrSdd;
};
